import { useFormContext } from "react-hook-form";
import { FormControl, Grid, Input, InputLabel } from "@mui/material";
import { PorukaGreskePolja } from "../../../index";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";

const Index = (props: any) => {
  const { register } = useFormContext();
  return (
    <Grid container spacing={2} sx={{ mt: 1, mb: 4 }}>
      <Grid item xs={12}>
        <FormControl
          fullWidth
          error={!daLiJePoljeValidno("poslovniNazivPlatforme")}
        >
          <InputLabel htmlFor={"poslovniNazivPlatforme"}>
            *Poslovni naziv platforme (Platform business name)
          </InputLabel>
          <Input
            aria-describedby="poslovni naziv platforme"
            {...register("poslovniNazivPlatforme")}
          />
          <PorukaGreskePolja nazivPolja={"poslovniNazivPlatforme"} />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default Index;
